import { Injectable } from '@angular/core';
import {
  SecureApplicationControllerService,
  SecureApplicationVerificationRequest,
  SecureApplicationVerificationResponse,
  ApplicationLogsControllerService,
  ApplicationDetailLog, SecureApplicationValidityResponse,
} from "leia-api";
import {NGXLogger} from "ngx-logger";
import { Observable } from "rxjs";
import {environment} from "../../../environments/environment";


@Injectable({
  providedIn: 'root',
})
export class CodeVerificationService {
  constructor(
    private secureApplicationService: SecureApplicationControllerService,
    private applicationLogService: ApplicationLogsControllerService,
    private logger: NGXLogger,
  ) { }

  verify(request: SecureApplicationVerificationRequest): Observable<SecureApplicationVerificationResponse> {
    return this.secureApplicationService.verify(request);
  }

  getSessionId(secureSessionId: string): Observable<string> {
    return this.secureApplicationService.getSessionIdBySecureId(secureSessionId);
  }

  getSessionData(sessionId: string): Observable<ApplicationDetailLog> {
    return this.applicationLogService.getApplicationLog(sessionId);
  }

  checkValidity(secureSessionId: string): Observable<SecureApplicationValidityResponse> {
    return this.secureApplicationService.checkValidity(secureSessionId);
  }

  /**
   * Method to generate Unique code.
   * @param secureSessionId
   */
  generateUniqueCode(secureSessionId: string) {
    this.secureApplicationService.generateUniqueCode(secureSessionId).subscribe((response: any) => {
      if(environment.development) console.warn("Generate Secure Attributes Executed Successfully");
    }, (error: any) => {
      this.logger.error("Failed to create secured onetime code - " + error);
    });
  }

  /**
   * Method to generate Unique Link & code.
   * @param sessionId
   */
  generateSecureAttributes(sessionId: string): Observable<string> {
    return this.secureApplicationService.generateSecureAttributesForBB8(sessionId)
  }
}
